import { render, staticRenderFns } from "./ErpDialog.vue?vue&type=template&id=931388f8&scoped=true&"
import script from "./ErpDialog.vue?vue&type=script&lang=js&"
export * from "./ErpDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931388f8",
  null
  
)

export default component.exports